import React from 'react'

import { isVillaOffer } from 'lib/offer/offerTypes'
import { CuratedBaseItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedBaseItemSelection'
import { CuratedProductImage } from 'tripPlanner/components/CuratedItemSelection/CuratedProductImage'
import { useOffer } from 'tripPlanner/hooks/api'
import { HomeAndVillasItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: HomeAndVillasItem
  onSelect: () => void
  isSelected: boolean
}

function getOfferImage(offer: App.VillaOffer) {
  const image = (offer as App.Offer).image
  if (image.id) {
    return { imgId: image.id }
  } else if (image.url) {
    return { imgSrc: image.url }
  }
  return {}
}

export function CuratedHomeAndVillaItemSelection({
  item,
  onSelect,
  isSelected,
}: Props) {
  const offerId = item.code

  const { data: offer } = useOffer(offerId)
  if (!isVillaOffer(offer)) {
    return null
  }

  const { imgId, imgSrc } = getOfferImage(offer)
  return (
    <CuratedBaseItemSelection
      type={item.type}
      title={item.place.name}
      onSelect={onSelect}
      isSelected={isSelected}
      image={
        <CuratedProductImage
          item={item}
          imgId={imgId}
          imgSrc={imgSrc}
          placeId={'id' in item.place ? item.place.id : undefined}
        />
      }
    />
  )
}
